import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Checkbox,
  styled,
  Box,
} from "@mui/material";
import { useField } from "formik";
import React from "react";
import { useTranslations } from "use-intl";

const CustomLabel = ({
  active,
  label,
  onChange = () => {},
}: {
  active: boolean;
  label: string;
  onChange?: () => void;
}) => (
  <Box display="flex" width="100%" alignItems="center" justifyContent="center">
    <StyledCheckbox checked={active} onClick={onChange} />
    <StyledLabel>{label}</StyledLabel>
  </Box>
);

const RadioGroupStatus = ({
  isCollection,
  ...props
}: {
  isCollection?: boolean;
  [key: string]: any;
}) => {
  const t = useTranslations("buy-sell-filter");
  const [field, meta, helpers] = useField(props as any);

  const onChange = () => {
    const value = field.value === "sale" ? "lease" : "sale";
    helpers.setValue(value);
  };

  return (
    <StyledFormControl>
      <RadioGroup row {...field}>
        <StyledFormControlLabel
          className={`${field.value === "sale" ? "active" : ""} ${
            isCollection ? "collection" : ""
          }`}
          value="sale"
          control={<Radio />}
          label={
            <CustomLabel
              label={t("shop")}
              active={field.value === "sale"}
              onChange={onChange}
            />
          }
        />
        <StyledFormControlLabel
          value="lease"
          className={`${field.value === "lease" ? "active" : ""} ${
            isCollection ? "collection" : ""
          }`}
          control={<Radio />}
          label={
            <CustomLabel
              label={t("sell")}
              active={field.value === "lease"}
              onChange={onChange}
            />
          }
        />
      </RadioGroup>
    </StyledFormControl>
  );
};

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  "& .MuiFormGroup-root": {
    display: "flex",
    flexWrap: "nowrap",
    position: "relative",
    left: 40,
    bottom: -3,
    [theme.breakpoints.down("lg")]: {
      left: 20,
    },
    [theme.breakpoints.down("md")]: {
      left: 20,
    },
  },
}));

const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  margin: 0,
  backgroundColor: "var(--color-brand-red-main)",
  color: "#fff",
  padding: "8px 20px",
  border: "none",
  outline: "none",
  borderRadius: "10px 10px 0px 0px",
  [theme.breakpoints.down("lg")]: {
    borderRadius: "10px",
  },
  [theme.breakpoints.down("md")]: {
    borderRadius: "10px",
  },
  "&.active": {
    backgroundColor: "var(--color-brand-red-tertiary)",
    transform: "scale(1.1)",
    transition: "0.2s",
    fontSize: "12px",
  },

  "& .MuiRadio-root": {
    display: "none",
    textAlign: "center",
  },
  "& .MuiFormControlLabel-label": {
    cursor: "pointer",
    fontWeight: 500,
    fontFamily: "var(--font-family)",
    width: "100%",
    textAlign: "center",
    fontSize: "12px",
  },
  "&.collection": {
    backgroundColor: "var(--color-brand-blue-main)",
  },
  "&.collection.active": {
    backgroundColor: "#404041",
  },
}));

const StyledLabel = styled("span")({
  cursor: "pointer",
  fontWeight: 500,
  fontFamily: "var(--font-family)",
  width: "100%",
  textAlign: "center",
  fontSize: "12px",
});

const StyledCheckbox = styled(Checkbox)({
  padding: 0,
  marginRight: 5,
  "& .MuiSvgIcon-root": {
    width: 15,
    height: 15,
    color: "var(--color-brand-bg-secondary)",
  },
});

export default RadioGroupStatus;
